export default "__VITE_PUBLIC_ASSET__2b74a470__"